const enUSJson = {
  common: {
    add: "Add",
    edit: "Edit",
    view: "View",
    update: "Update",
    delete: "Delete",
    actions: "Actions",
    apply: "Apply",
    reset: "Reset",
    menu: "Menu",
    search: "Search",
    noSearchResults: "No results found",
    noDataAvailable: "No Data Available",
    noOptions: "No options",
    loadingText: "We are loading the data for you. Please wait.",
    cancel: "Cancel",
    select: "Select",
    close: "Close",
    save: "Save",
    saveSuccess: "{{name}} saved successfully.",
    yes: 'Yes',
    no: 'No',
    expand: "Expand",
    collapse: "Collapse",
    downloadPDF: "Download as PDF",
    downloadCSV: "Download as CSV",
    downloadExcel: "Download as Excel",
    tips: {
      downloadFailed: "Download failed."
    },
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
      jsonError: 'Incorrect JSON format. Please enter the correct JSON format.'
    },
    jsonLabel: 'JSON',
    next: "Next",
    disable: "Disable",
    enable: "Enable",
    editable: "Editable",
    readOnly: "Read Only",
    status: "Status",
    type: "Type",
    mandatory: "Mandatory",
    selectAll: "Select All",
    pleaseSelect: "Please select",
  },
  validation: {
    isRequired: "is required",
    regexErrorTip: 'Please enter a valid format',
    numberTooSmallTip: 'The value must be at least {{number}}',
    numberTooBigTip: 'The value must be at most {{number}}',
    numberIntegerOnly: 'Integer only',
    numberMaxDecimalPlaces: "No more than {{number}} decimal places",
    dateTooEarlyTip: 'The selected date must be later than {{date}}',
    dateTooLateTip: 'The selected date must be earlier than {{date}}',
    stringTooShortTip: 'The input characters must be at least {{number}}',
    stringTooLongTip: 'The input exceeds the maximum limit of {{number}}'
  },
  menu: {
    eventLibrary: "Event Library",
    timelineTemplate: "Timeline Library",
    timelineManager: "Timeline Manager",
    eventManager: "Event Manager",
  },
  eventLibrary: {
    eventLibrary: 'Event',
    eventTemplate: 'Event Template',
    eventID: 'Event ID',
    eventName: 'Event Name',
    fieldName: 'Field Name',
    module: 'Module',
    eventCategory: 'Event Category',
    description: 'Description',
    businessTypeID: "Primary Business Object Type ID",
    isMilestone: 'Mark as milestone',
    basicInformation: 'Basic Information',
    createEvent: 'Create New Event Template',
    userDefinedFields: 'User Defined Fields',
    moduleDefinedProperties: 'Module Defined Properties',
    optional: 'Optional',
    addField: 'Add Field',
    addProperty: 'Add Property',
    key: 'Property Name',
    value: 'Property Value',
    eventIdTip: 'Auto-generated upon creation',
    autoGenerated: 'Auto-generated',
    duplicateFieldName: 'Duplicate event field name. Please choose a different name.',
    duplicateBusinessPrimaryType: 'Module with the same primary business object type ID already exists.',
    fieldValue: 'Field Value',
    fieldType: 'Field Type',
    fieldTypeText: 'Text',
    fieldTypeDate: 'Date',
    businessPrimaryObject: "Primary Business Object",
    eventInteractionConfiguration: "Event Interaction Configuration",
    trackingScope: "Tracking Scope",
    doNotTrack: "Do not track",
    withinProject: "Within Project",
    manuallySelectInInstance: "Manually select in instance",
    tracking: "Tracking",
    trackingRequired: "Tracking is required",
    addTrackingEvent: "Add Tracking Event",
    autoCompleteWhenAllTrackingCompleted:
      "Auto complete when all tracking event completed",
    addSuccessTip: 'Template added successfully.',
    updateSuccessTip: 'Template updated successfully.'
  },
  timelineLibrary: {
    timeline: "Timeline",
    templateId: "Template ID",
    templateName: "Template Name",
    applicableProjectType: "Applicable Project Type",
    module: "Module",
    selectModule: "Select Module",
    selectPrimaryBusinessObject: "Select Primary Business Object",
    events: "Events",
    basicInformation: "Basic Information",
    description: "Description",
    addTemplate: "Add Timeline Template",
    editTemplate: "Edit Timeline Template",
    viewTemplate: "View Timeline Template",
    view: "View",
    back: "Back",
    autoGenerated: "Auto-generated",
    templateIdTip: "Auto-generated upon creation",
    leadTimeHelper:
      "Lead time in days relative to the project planned start date (integer from 1 to 500).",
    seq: "SEQ",
    eventName: "Event Name",
    primaryBusinessObject: "Primary Business Object",
    leadTimeDays: "Lead Time (Days)",
    addEvent: "Add Event",
    selectEventName: "Select Event Name",
    leadTimePlaceholder: "e.g. 30",
    eventsSection: "Events",
    eventsRequired: "Add at least one event row before saving.",
    leadTimeInvalid:
      "Lead time must be a whole number from 1 to 500.",
    duplicateEvent: "Each event can only be added once to this template.",
    duplicateTemplateName: "A template with this name already exists.",
    invalidEventBinding:
      "This event is not eligible for the selected Primary Business Object (missing tracking events or PBO association). Replace or remove it before saving.",
    eventsEmpty: "This template does not contain any events.",
    templateNotFound: "Timeline template was not found.",
    deleteConfirmTitle: "Delete Timeline Template",
    deleteConfirmMessage:
      "Permanently remove \"{{name}}\" from the timeline library? This cannot be undone.",
    addSuccessTip: "Timeline template added successfully.",
    updateSuccessTip: "Timeline template updated successfully.",
    dragToReorder: "Drag to reorder",
    moveRowUp: "Move event row up",
    moveRowDown: "Move event row down",
  },
  timelineInstance: {
    addTimeline: "Add Timeline",
    viewTimeline: "View Timeline",
    basicInformation: "Basic Information",
    timelineTemplate: "Timeline Template",
    selectTemplate: "Select Timeline Template",
    templateRequired: "Please select a Timeline Template.",
    noTemplates:
      "No Timeline Templates are available for this Primary Business Object.",
    missingContext:
      "Business record context is incomplete. Open Add Timeline from the hosting module.",
    missingViewContext:
      "Business record context is incomplete. Open View Timeline Instance from the hosting module.",
    addSuccessTip: "Timeline Instance created successfully.",
    viewEmpty: "No Timeline Instance exists for this business record.",
    viewLoadFailed: "Unable to load Timeline Instance.",
    cardEvents: "Events",
    cardCompleted: "Completed",
    cardDelayed: "Delayed",
    cardUnplanned: "Unplanned",
    eventTimeline: "Events Timeline",
    trackingEvents: "Tracking Events",
    trackingEmpty: "No tracking data",
    colEventInstanceId: "Event Instance ID",
    colEventName: "Event Name",
    colPrimaryBusinessObject: "Primary Business Object",
    colPrimaryBusinessObjectType: "Primary Business Object Type",
    colBusinessObjectId: "Business Object ID",
    colMilestone: "Milestone",
    colPlannedDate: "Planned Date",
    colActualDate: "Actual Date",
    colEventStatus: "Event Status",
    milestoneYes: "Yes",
    milestoneNo: "No",
    statusCompleted: "Completed",
    statusPlanned: "Planned",
    statusDelayed: "Delayed",
    statusUnplanned: "Unplanned",
  },
  tenantData: {
    tenantData: 'Tenant Data',
    importTenantData: 'Import Tenant Data',
    exportTenantData: 'Export Tenant Data',
    dragDropText: 'Drag & drop files here or click on select',
    selectFile: 'Select File',
    importSummary: 'Import Summary',
    errorSummary: 'Error Summary',
    importErrorIntro: 'Import was not proceed due to the following errors:',
    importSuccessMsg: 'Successfully imported Event templates: {{quantity}}.',
    duplicateEventMsg: 'Below event names already exist in {{moduleObject}}. Please change names and import again.',
  }
};

export default enUSJson;
